module.exports = "/_next/static/images/macpunks-ultrawide-header-85f0b00c200cb37eac261eb6e83c0186.jpg";